import { STATUS } from '@/views/PesosCocidos/cookedWeightsConstants'
import { isWeighableGroup } from '@/utils/mealServingTotals'

const PERCENT_FACTOR = 100
const PERCENT_ROUNDING_FACTOR = 100
const NO_WEIGHT = 0

function toHundredths (percent) {
  return Math.round(percent * PERCENT_ROUNDING_FACTOR) / PERCENT_ROUNDING_FACTOR
}

function roundDownToPercent (percent) {
  return Math.floor(toHundredths(percent))
}

export function roundUpToPercent (percent) {
  return Math.ceil(toHundredths(Number(percent)))
}

function measuredGramsOf (group) {
  if (group.status === STATUS.WEIGHED) {
    return group.real_weight_grams
  }
  return group.status === STATUS.SHORT_WEIGHED ? group.short_weight_grams : null
}

function isPositive (value) {
  return value !== null && value !== undefined && Number(value) > NO_WEIGHT
}

export function describeGroupYield (group) {
  const measuredGrams = measuredGramsOf(group)
  if (!isWeighableGroup(group) || !isPositive(group.reduction_percent) || !isPositive(group.raw_day_grams) ||
    measuredGrams === null || measuredGrams === undefined) {
    return null
  }
  const theoreticalPercent = roundUpToPercent(group.reduction_percent)
  const realPercent = roundDownToPercent(Number(measuredGrams) / Number(group.raw_day_grams) * PERCENT_FACTOR)
  return { theoreticalPercent, realPercent }
}
